"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DomainEvent_1 = require("../Engine/Event/DomainEvent");
const UserDefinition_1 = require("./UserDefinition");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
class UserEvent {
    static UserIsOnlineEvent(u) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.UserIsOnline,
            entityId: u.id,
            body: u
        });
    }
    static UserIsOfflineEvent(u) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.UserIsOffline,
            entityId: u.id,
            body: u
        });
    }
    static UserStatusUpdatedEvent(u) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.UserStatusUpdated,
            entityId: u.id,
            body: u
        });
    }
    static ContactIsAddedEvent(u, c, contactUserDto) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.ContactIsAdded,
            entityId: u.id,
            body: new TypeScriptUtils_1.Tuple2({
                Item1: c,
                Item2: contactUserDto
            }),
        });
    }
    static ContactIsRemovedEvent(u, c, contactUserDto) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.ContactIsRemoved,
            entityId: u.id,
            body: new TypeScriptUtils_1.Tuple2({
                Item1: c,
                Item2: contactUserDto
            }),
        });
    }
    static ContactIsHiddenEvent(u, c, contactUserDto) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.ContactIsHidden,
            entityId: u.id,
            body: new TypeScriptUtils_1.Tuple2({
                Item1: c,
                Item2: contactUserDto,
            })
        });
    }
    static ContactIsBlockedEvent(u, c, contactUserDto) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.ContactIsBlocked,
            entityId: u.id,
            body: TypeScriptUtils_1.NewTuple2(c, contactUserDto)
        });
    }
    static ContactIsRecoverdEvent(u, c, contactUserDto) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.ContactIsRecoverd,
            entityId: u.id,
            body: TypeScriptUtils_1.NewTuple2(c, contactUserDto)
        });
    }
    static ContactBecameFavoriteEvent(u, c, contactUserDto) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.ContactBecameFavorite,
            entityId: u.id,
            body: TypeScriptUtils_1.NewTuple2(c, contactUserDto)
        });
    }
    static ContactBecameNotFavoriteEvent(u, c, contactUserDto) {
        return new DomainEvent_1.DomainEvent({
            version: UserEvent.Version,
            category: UserEvent.Category,
            name: UserEvent.ContactBecameNotFavorite,
            entityId: u.id,
            body: TypeScriptUtils_1.NewTuple2(c, contactUserDto)
        });
    }
}
UserEvent.Version = UserDefinition_1.UserVersion;
UserEvent.Category = UserDefinition_1.UserEventCategory;
UserEvent.UserIsOnline = "UserIsOnline";
UserEvent.UserIsOffline = "UserIsOffline";
UserEvent.UserStatusUpdated = "UserStatusUpdated";
UserEvent.ContactIsAdded = "ContactsIsAdded";
UserEvent.ContactIsRemoved = "ContactIsRemoved";
UserEvent.ContactIsHidden = "ContactIsHidden";
UserEvent.ContactIsBlocked = "ContactIsBlocked";
UserEvent.ContactIsRecoverd = "ContactIsRecoverd";
UserEvent.ContactBecameFavorite = "ContactBecameFavorite";
UserEvent.ContactBecameNotFavorite = "ContactBecameNotFavorite";
exports.UserEvent = UserEvent;
//# sourceMappingURL=UserEvent.js.map